import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableExporterComponent} from './table-exporter.component';
import {ButtonModule} from '@ucx/ui-cmp';
import {TableExporterService} from './table-exporter.service';

@NgModule({
    declarations: [
        TableExporterComponent
    ],
    imports: [
        CommonModule,
        ButtonModule
    ],
    exports: [
        TableExporterComponent
    ],
    providers: [TableExporterService]
})
export class TableExporterModule {
}
